import { Component } from '@angular/core';

@Component({
  selector: 'jhi-hi-robot',
  templateUrl: './hi-robot.component.html',
})
export class HiRobotComponent {
  constructor() {}
}
